/**
 * Смена домена на клиенте
 */
export const changeCity = (
    newCityDomain: string,
    newProviderId: number,
) => {
    const { protocol, pathname } = window.location;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.append('nextProviderId', `${newProviderId}`);

    const [, ...splittedHost] = window.location.host.split('.');

    const host = `${protocol}//${newCityDomain}.${splittedHost.join('.')}`;

    window.location.replace(`${host}${pathname}?${searchParams.toString()}`);
};
